import ActivosFijosScreen from "../../Screen/ERP/Global/ActivosFijos/ActivosFijosScreen";
import ComprobanteRetencionScreen from "../../Screen/Finanzas/Proveedores/ComprobanteRetencion/ComprobanteRetencionScreen";
import NotasCreditoProveedorScreen from "../../Screen/Finanzas/Proveedores/Notas/NotasCreditoProveedorScreen";
import ConceptoRetencionScreen from "../../Screen/Finanzas/Proveedores/Retencion/ConceptoRetencionScreen";
import AccountTypeScreen from "../../Screen/Finanzas/RegistroContable/AccountTypeScreen";
import CategoriesScreen from "../../Screen/Finanzas/RegistroContable/CategoriesScreen";
import CharAccountScreen from "../../Screen/Finanzas/RegistroContable/CharAccountScreen";
import RangosScreen from "../../Screen/Finanzas/RegistroContable/DocumentRanges/RangosScreen";
import LibroDiarioScreen from "../../Screen/Finanzas/RegistroContable/LibroDiario/LibroDiarioScreen";
import SubCategoriesScreen from "../../Screen/Finanzas/RegistroContable/SubCategoriesScreen";
import RegistroFacturasScreen from "../../Screen/Finanzas/RegistroFacturas/RegistroFacturasScreen";
import SalidasScreen from "../../Screen/Finanzas/BodegaMateriales/SalidasScreen";
import DevolucionesScreen from "../../Screen/Finanzas/BodegaMateriales/DevolucionesScreen";
import ProveedoresScreen from "../../Screen/ERP/Compras/Proveedores/ProveedoresScreen";
import BoletaCompraScreen from "../../Screen/Finanzas/CajaChica/BoletaCompraScreen";
import ComprobanteCajaChicaScreen from "../../Screen/Finanzas/CajaChica/ComprobanteCajaChicaScreen";


export const Finanzas = [

    //******************************************************************************************************** */
    //--------------------------------------REGISTRO CONTABLE---------------------------------------------------
    {
        path: "Finanzas/PlanCuentas",
        permiso: 85,
        element: <CharAccountScreen />,
    },
    {
        path: "Finanzas/TipoCuentas",
        permiso: 86,
        element: <AccountTypeScreen />,
    },
    {
        path: "Finanzas/Categorias",
        permiso: 87,
        element: <CategoriesScreen />,
    },
    {
        path: "Finanzas/SubCategorias",
        permiso: 88,
        element: <SubCategoriesScreen />,
    },
    {
        path: "Finanzas/CXP/RegistroFacturas",
        permiso: 94,
        element: <RegistroFacturasScreen />,
    },

    {
        path: "Finanzas/RangosDocumentos",
        permiso: 97,
        element: <RangosScreen/>,
    },

    //**********************************--- RETENCION ---************************************************* */
    {
        path: "Fin/Retencion/ConceptoRetencion",
        permiso: 102,
        element: <ConceptoRetencionScreen/>,
    },
    {
        path: "Fin/Retencion/CompRetencion",
        permiso: 103,
        element: <ComprobanteRetencionScreen/>,
    },

    //**********************************--- RETENCION ---************************************************* */
    {
        path: "Finanzas/Proveedores/NotaCredito",
        permiso: 104,
        element: <NotasCreditoProveedorScreen/>,
    },

    {
        path: "Finanzas/RegistroContable/LibroDiario",
        permiso: 105,
        element: <LibroDiarioScreen />,
    },
    {
       // path: "Activos/ActivosFijos",
        path: "Finanzas/ActivosFijos",
        permiso: 108,
        element: <ActivosFijosScreen Finanzas={true} />,
    },
    {
        path: "Finanzas/BodegaMateriales/Salidas",
        permiso: 118,
        element: <SalidasScreen />,
    },
    {
        path: "Finanzas/BodegaMateriales/Devoluciones",
        permiso: 120,
        element: <DevolucionesScreen />,
    },
    {
        path: "Finanzas/Proveedores",
        permiso: 121,
        element: <ProveedoresScreen Finanzas={true}/>,
    },
    {
        path: "Finanzas/CajaChica/BoletaCompra",
        permiso: 123,
        element: <BoletaCompraScreen/>,
    },
    {
        path: "Finanzas/CajaChica/ComprobanteCajaChica",
        permiso: 124,
        element: <ComprobanteCajaChicaScreen />,
    },
];
  
export default Finanzas;
  